import { render, staticRenderFns } from "./ProjectLandingPage.vue?vue&type=template&id=5de002d2&scoped=true"
import script from "./ProjectLandingPage.vue?vue&type=script&lang=js"
export * from "./ProjectLandingPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectLandingPage.vue?vue&type=style&index=0&id=5de002d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de002d2",
  null
  
)

export default component.exports